import { generateUtilityClasses } from '@mui/material';

export const tableRowClasses = generateUtilityClasses('TableRow', [
  'collapse',
  'collapseContent',
  'open',
  'subRow',
]);
